import React from 'react';

const Gender = ({ updateProfile, profileData }) => {
  const handleChange = (event) => {
    const { name, value } = event.target;
    updateProfile(name, value);
  };

  return (
    <fieldset className="form-group form-group--no-validation">
      <legend className="form-group__title">Gender</legend>
      <span className="form-group__radio">
        <input
          name="gender"
          type="radio"
          value="female"
          id="female"
          onChange={handleChange}
          checked={profileData.gender === 'female'}
        ></input>
        <label htmlFor="female">Female</label>
      </span>
      <span className="form-group__radio">
        <input
          name="gender"
          type="radio"
          value="male"
          id="male"
          onChange={handleChange}
          checked={profileData.gender === 'male'}
        ></input>
        <label htmlFor="male">Male</label>
      </span>
      <span className="form-group__radio">
        <input
          name="gender"
          type="radio"
          id="other"
          value="other"
          onChange={handleChange}
          checked={profileData.gender === 'other'}
          aria-describedby="genderOther"
        ></input>
        <label htmlFor="other">Other</label>
        <span className="tooltip">
          <span className="tooltip_box">
            <small className="tooltip_text" id="genderOther">
              You&apos;ll have the opportunity to self-describe in your ad(s)
              and messages, if you choose to
            </small>
            <span className="tooltip_arrow">&nbsp;</span>
          </span>
          <span className="tooltip_item">
            <i className="fas fa-info-circle"></i>
          </span>
        </span>
      </span>
    </fieldset>
  );
};

export default Gender;
